<template>
  <input
    :ref="`textInput_child_${refId}`"

    :value="textInput_child"
    :type="inputType"
    :placeholder="placeholder"

    class="input-area no-spinner"
    :class="focusBoxShadow ? `focus-box-shadow-and-border-color-687EFF textInput_child_${refId}` : `textInput_child_${refId}`"
    style="width: 100%; background-color: #ffffff; border-radius: 8px; font-weight: 400; line-height: 20px; color: #0D0E17"
    :style="{height: height, border: border, padding: padding, fontSize: fontSize}"

    @input="onInput"
    @compositionend="onCompositionEnd"
    @keyup.enter="keyup_enter"
    @keyup.esc="keyup_esc"
    @keydown.tab.exact.prevent="onTab"
    @keydown.shift.tab.exact.prevent="onShiftTab"
  >
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: "TextInput",

  props: {
    textInput: {
      type: String,
      default: '',
    },
    inputType: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },

    refId: {
      type: String,
      default: '',
    },

    // style 관련
    focusBoxShadow: {
      type: Boolean,
      default: true,
    },
    height: {
      type: String,
      default: '38px',
    },
    border: {
      type: String,
      default: '1px solid #E8EAF2',
    },
    padding: {
      type: String,
      default: '0px 16px',
    },
    fontSize: {
      type: String,
      default: '14px',
    },
  },

  data() {
    return {
      textInput_child: '',
      readyToEmit: false, // ✅ 초기 세팅 중 emit 막기
    }
  },

  methods: {
    onInput(event) {
      if (this.inputType === 'number' && event.isComposing) return
      let val = event.target.value
      if (this.inputType === 'number') {
        val = val.replace(/[^0-9]/g, '')
        event.target.value = val
      }
      this.textInput_child = val
    },
    onCompositionEnd(event) {
      if (this.inputType !== 'number') return
      const val = event.target.value.replace(/[^0-9]/g, '')
      event.target.value = val
      this.textInput_child = val
    },
    keyup_enter() {
      console.log('keyup_enter')
      this.$emit('set_keyup_enter')
    },
    keyup_esc() {
      console.log('keyup_esc')
      this.$emit('set_keyup_esc')
    },
    onTab() {
      // 부모에게 다음 셀로 이동하라고 알림 (방향: 'next')
      this.$emit('tab-navigation', 'next');
    },
    onShiftTab() {
      // 부모에게 이전 셀로 이동하라고 알림 (방향: 'prev')
      this.$emit('tab-navigation', 'prev');
    },
  },

  created() {
    // console.log('TextInput created')
    this.emitDebounced = debounce(v => {
      this.$emit('set_textInput', v)
    }, 150)
  },

  mounted() {
    // console.log('TextInput mounted')
    // console.log('textInput', this.textInput)

    this.textInput_child = this.textInput
    // console.log('textInput_child', this.textInput_child)

    // ✅ 초기 값 세팅 후부터만 emit 허용
    this.$nextTick(() => {
      this.readyToEmit = true
    })
  },

  watch: {
    textInput_child(textInput_child) {
      if (!this.readyToEmit) return // ✅ mounted 초기 동기화는 무시
      this.emitDebounced(textInput_child)
    },

    // (옵션) 부모에서 textInput prop이 바뀌면 input도 동기화하되 emit은 안 함
    textInput(newVal) {
      this.readyToEmit = false
      this.textInput_child = newVal
      this.$nextTick(() => {
        this.readyToEmit = true
      })
    },
  },
  
}
</script>

<style>

</style>